import {
  Wifi, Car, CarFront, Bike, Utensils, WashingMachine, Sparkles, Droplet, Zap, Cctv, Shield,
  Trees, Sofa, AirVent, Fan, Bath, ShowerHead, Bed, Shirt, Table, Armchair,
  Tv, Flame, Refrigerator, Blinds, Gauge, CircleDot,
} from "lucide-react";

// Maps the amenity.icon string (stored in DB) to a lucide-react icon component.
const ICONS = {
  wifi: Wifi,
  car: Car,
  "car-front": CarFront,
  bike: Bike,
  utensils: Utensils,
  "washing-machine": WashingMachine,
  sparkles: Sparkles,
  droplet: Droplet,
  zap: Zap,
  cctv: Cctv,
  shield: Shield,
  trees: Trees,
  sofa: Sofa,
  "air-vent": AirVent,
  fan: Fan,
  bath: Bath,
  "shower-head": ShowerHead,
  bed: Bed,
  shirt: Shirt,
  table: Table,
  armchair: Armchair,
  tv: Tv,
  flame: Flame,
  refrigerator: Refrigerator,
  gauge: Gauge,
  blinds: Blinds,
};

export function AmenityIcon({ name, ...props }) {
  const Icon = ICONS[name] || CircleDot;
  return <Icon {...props} />;
}

export const AMENITY_CATEGORY_LABELS = {
  property: "Fasilitas Utama",
  common: "Fasilitas Bersama",
  security: "Keamanan",
  service: "Layanan",
  room: "Fasilitas Kamar",
  other: "Lainnya",
};

const CATEGORY_ORDER = ["property", "common", "security", "service", "room", "other"];

export function groupByCategory(amenities) {
  const groups = {};
  for (const a of amenities) {
    (groups[a.category] = groups[a.category] || []).push(a);
  }
  return CATEGORY_ORDER.filter((c) => groups[c]?.length).map((c) => ({
    category: c,
    label: AMENITY_CATEGORY_LABELS[c] || c,
    items: groups[c],
  }));
}
